import { render, staticRenderFns } from "./友情链接.vue?vue&type=template&id=5f0fbb3c&scoped=true"
import script from "./友情链接.vue?vue&type=script&lang=js"
export * from "./友情链接.vue?vue&type=script&lang=js"
import style0 from "./友情链接.vue?vue&type=style&index=0&id=5f0fbb3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0fbb3c",
  null
  
)

export default component.exports